import _tslib from "tslib";
import { dew as _PDFAnnotationDew } from "./PDFAnnotation";
import { dew as _PDFWidgetAnnotationDew } from "./PDFWidgetAnnotation";
import { dew as _AppearanceCharacteristicsDew } from "./AppearanceCharacteristics";
import { dew as _flagsDew } from "./flags";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var tslib_1 = _tslib;

  var PDFAnnotation_1 = _PDFAnnotationDew();

  Object.defineProperty(exports, "PDFAnnotation", {
    enumerable: true,
    get: function () {
      return PDFAnnotation_1.default;
    }
  });

  var PDFWidgetAnnotation_1 = _PDFWidgetAnnotationDew();

  Object.defineProperty(exports, "PDFWidgetAnnotation", {
    enumerable: true,
    get: function () {
      return PDFWidgetAnnotation_1.default;
    }
  });

  var AppearanceCharacteristics_1 = _AppearanceCharacteristicsDew();

  Object.defineProperty(exports, "AppearanceCharacteristics", {
    enumerable: true,
    get: function () {
      return AppearanceCharacteristics_1.default;
    }
  });

  tslib_1.__exportStar(_flagsDew(), exports); //# sourceMappingURL=index.js.map


  return exports;
}